// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"f5b6dae691894b8a9da3","454":"c66882ed2ad610f706c3"}[chunkId] + ".js";
};